import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Form, Row, Space } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomDatePicker from '../../../v2-components/Antd/DatePicker';
import CustomDivider from '../../../v2-components/Antd/Divider';
import CustomDragSortTable from '../../../v2-components/Antd/DragTable';
import CustomFormItem from '../../../v2-components/Antd/FormItem';
import CustomInput from '../../../v2-components/Antd/Input';
import CustomLink from '../../../v2-components/Antd/Link';
import CustomModal from '../../../v2-components/Antd/Modal';
import CustomRadio from '../../../v2-components/Antd/Radio';
import CustomRadioGroup from '../../../v2-components/Antd/RadioGroup';
import CustomSwitch from '../../../v2-components/Antd/Switch';
import CustomTimePicker from '../../../v2-components/Antd/TimePicker';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import useLandingStore from '../store/useLandingStore';
import { nameAdapter } from './handle/name-adapter.handle';
import { tableAdapter } from './handle/table-adapter.handle';
import { Service } from './service';
import './style.scss';

export default function LandingDetailPage() {
	const [openDeleteModalOpen, setOpenDeleteModal] = useState(false);
	const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
	const [radioValue, setRadioValue] = useState(true);
	const [loading, setLoading] = useState(false);
	const [fileToDelete, setFileToDelete] = useState(null);
	const history = useHistory();
	const [form] = Form.useForm();
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [platform, currentPage, pageData, mainData, setStatus, setPageData, setMainData, setCurrentSection] = useLandingStore((state) => [
		state.platform,
		state.currentPage,
		state.pageData,
		state.mainData,
		state.setStatus,
		state.setPageData,
		state.setMainData,
		state.setCurrentSection,
		state.setStatus,
	]);
	const handleDragSortEnd = (beforeIndex, afterIndex, newDataSource) => {
		newDataSource.forEach((file, index) => {
			file.position = index + 1;
		});

		const positionDataSource = newDataSource.map((file) => {
			return { position: file.position, _id: file._id };
		});
		setLoading(true);
		new Service()
			.updatePosition(positionDataSource, currentPage, platform, 'landing')
			.then((response) => {
				setLoading(false);
				setPageData(response);
				setMainData({ ...mainData, [`page${currentPage}`]: response });
			})
			.catch((error) => console.log('error', error));
	};
	const handleRadioChange = (e) => {
		setRadioValue(e.target.value);
	};

	const handleOnFinish = () => {
		const body = { ...form.getFieldsValue(), country: Enviroment.COUNTRY, root_pharmacy: platform, page: +currentPage, section: 'landing' };
		setOpenLoadingModal(true);
		if (pageData.length < 1) {
			new Service()
				.create(body)
				.then((response) => {
					console.log('response', response);
					if (response.statusCode === 400) {
						setOpenLoadingModal(false);
						return CustomNotification({
							type: 'error',
							message: 'Error',
							description: 'El slug ya se encuentra en uso. Elija otro nombre',
						});
					}
					setOpenLoadingModal(false);
					setPageData(response);
					setMainData({ ...mainData, [`page${currentPage}`]: response });
				})
				.catch((error) => console.log(error));
		} else {
			new Service()
				.updateType(body)
				.then((response) => {
					if (response.statusCode === 400) {
						setOpenLoadingModal(false);
						return CustomNotification({ type: 'error', message: 'Error', description: 'El slug  ya se encuentra en uso' });
					}
					setOpenLoadingModal(false);
					setPageData(response);
					setMainData({ ...mainData, [`page${currentPage}`]: response });
				})
				.catch((error) => {
					console.log('error', error);
				});
		}
	};

	const handleCreate = () => {
		if (pageData.length === 1 && !pageData[0].tag) {
			console.log('entro aca');
			setCurrentSection(pageData);
		} else {
			setCurrentSection([]);
		}
		history.push('/landing/create');
	};

	const handleSwitchChange = (row, checked) => {
		setLoading(true);
		new Service()
			.updateStatus({ _id: row._id, status: checked })
			.then((response) => {
				setLoading(false);
				setPageData(response);
				setMainData({ ...mainData, [`page${currentPage}`]: response });
			})
			.catch((error) => {
				console.log('error', error);
			});
	};

	const handleOpenDeleteModal = (record, index) => {
		setOpenDeleteModal(true);
		setFileToDelete(record);
	};

	const handleConfirmDelete = () => {
		setOpenDeleteModal(false);
		setOpenLoadingModal(true);
		if (pageData.length === 1) {
			const { editable_name, _id, tag, created_at, updated_at, __v, ...rest } = pageData[0];
			const modifiedPageData = {
				...rest,
				products: [],
				isPageActive: false,
				status: false,
			};
			new Service()
				.update(fileToDelete._id, modifiedPageData)
				.then((response) => {
					console.log('response', response);
					setOpenLoadingModal(false);
					setPageData([response]);
					setMainData({ ...mainData, [`page${currentPage}`]: [response] });
					setCurrentSection([]);
					setStatus(false, `page${currentPage}`);
				})
				.catch((error) => console.log('error', error));
			return;
		}
		new Service()
			.delete(fileToDelete._id)
			.then((response) => {
				const positionResponse = response.map((file, index) => {
					return { position: index + 1, _id: file._id };
				});
				console.log('positionResponse', positionResponse);
				new Service()
					.updatePosition(positionResponse, currentPage, platform, 'landing')
					.then((response) => {
						setOpenLoadingModal(false);
						setPageData(response);
						setMainData({ ...mainData, [`page${currentPage}`]: response });
						if (response.length === 0) {
							setCurrentSection([]);
							setStatus(false, `page${currentPage}`);
							form.resetFields();
						}
					})
					.catch((error) => console.log('error', error));
			})
			.catch((error) => console.log(('error', error)));
	};

	const columns = [
		{
			title: 'Orden',
			dataIndex: 'order',
		},
		{
			title: 'Plataforma',
			dataIndex: 'root_pharmacy',
			render: (row) => nameAdapter(row),
		},
		{
			title: 'Página',
			dataIndex: 'link_name',
		},
		{
			title: 'Título de sección (visible en la web)',
			dataIndex: 'editable_name',
		},
		{
			title: 'Estado',
			dataIndex: 'status',
			key: 'switch',
			align: 'center',
			width: 80,
			render: (_, row, index) => (
				<CustomSwitch checked={row.status} onChange={(checked) => handleSwitchChange(row, checked)} className="custom-switch" />
			),
		},
		{
			title: 'Acciones',
			dataIndex: 'acciones',
			key: 'delete',
			align: 'center',
			width: 80,
			render: (_, record, index) => (
				<DeleteOutlined style={{ fontSize: '24px', cursor: 'pointer' }} onClick={() => handleOpenDeleteModal(record, index)} />
			),
		},
		{
			title: 'Ver más',
			dataIndex: 'ver mas',
			key: 'switch',
			align: 'center',
			width: 80,
			render: (_, row, index) => (
				<SearchOutlined
					style={{ fontSize: '24px' }}
					onClick={() => {
						setCurrentSection([row]);
						// handleCheckProducts(row);
						history.push('/landing/create');
					}}
				/>
			),
		},
	];

	return (
		<div className="admin-landing-detail">
			<h1>
				{nameAdapter(platform)} / {`Página promocional ${currentPage}`}
			</h1>
			<CustomLink to={`/landing`}>{`Volver a ${nameAdapter(platform)}`}</CustomLink>
			<CustomCard>
				<Form
					form={form}
					initialValues={{ link_name: pageData[0]?.link_name, type: pageData[0]?.type }}
					onFinish={handleOnFinish}
					className="create-form"
				>
					<h2>Datos de la página</h2>
					<Row style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Col lg={10}>
							<p>Titulo del enlace (visible en el header de la web)</p>
							<CustomFormItem name={'link_name'} rules={'required'}>
								<CustomInput />
							</CustomFormItem>
						</Col>
						<Col lg={10}>
							<p>Slug de la página (visible en la barra de navegación)</p>
							<CustomFormItem name={'type'} rules={('required', 'alphanumeric')}>
								<CustomInput />
							</CustomFormItem>
							<p>No usar espacios, reemplazar con - (guión medio). Ej: hola-mundo </p>
						</Col>
					</Row>
					<Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<div>
							<p>Para que la página se muestre debes completar los campos superiores y tener una sección activa.</p>
						</div>
						<div style={{ display: 'flex', gap: '10px' }}>
							<CustomButton onClick={() => form.resetFields()}>CANCELAR</CustomButton>
							<CustomButton htmlType="submit">GUARDAR</CustomButton>
						</div>
					</Row>
				</Form>
			</CustomCard>
			<Row className="results-landing-container" gutter={[16, 16]} style={{ marginTop: '40px' }}>
				<Col md={24} xs={24}>
					<CustomCard
						className="modules-card-landing"
						title={
							<div
								className="card-header-landing-container"
								style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
							>
								<h2>Lista de secciones</h2>
								<div className="inner-container">
									<CustomButton disabled={pageData.length < 1} onClick={handleCreate}>
										Crear
									</CustomButton>
								</div>
							</div>
						}
					>
						<CustomDragSortTable
							loading={loading}
							headerTitle=""
							rowKey="key"
							search={false}
							pagination={false}
							columns={columns}
							dataSource={pageData[0]?.tag ? tableAdapter(pageData) : []}
							dragSortKey="order"
							onDragSortEnd={handleDragSortEnd}
						/>
					</CustomCard>
				</Col>
			</Row>
			<CustomModal
				title="Eliminar sección"
				open={openDeleteModalOpen}
				centered
				onOk={handleConfirmDelete}
				onCancel={() => setOpenDeleteModal(false)}
				okText="Eliminar"
				cancelText="Cancelar"
			>
				<CustomDivider />
				<p>¿Estas seguro de que deseas eliminar la sección seleccionada?</p>
				<p>Recuerda que al eliminar tambien se eliminara la lista de productos creada.</p>
				<CustomDivider />
			</CustomModal>

			<CustomModal
				width={700}
				title="Cambio de estado de la sección"
				open={isScheduleModalOpen}
				centered
				onCancel={() => setIsScheduleModalOpen(false)}
				okText="Guardar"
				cancelText="Cancelar"
			>
				<CustomDivider />
				<h3>Estado</h3>
				<p>Desde aquí puedes activar, desactivar o programar la visualización de la sección</p>
				<CustomRadioGroup onChange={handleRadioChange} value={radioValue}>
					<Space direction="vertical">
						<CustomRadio value={1}>Activar</CustomRadio>
						<CustomRadio value={2}>Desactivar</CustomRadio>
						<CustomRadio value={3}>Programar</CustomRadio>
					</Space>
				</CustomRadioGroup>
				<Col style={{ marginTop: '30px' }}>
					<p>Inicio</p>
					<div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
						<CustomDatePicker placeholder="Seleccionar fecha" format="DD/MM/YYYY" style={{ width: '50%' }} />
						<CustomTimePicker placeholder="Seleccionar hora" format="HH:mm" style={{ width: '50%' }} />
					</div>
					<p>Fin</p>
					<div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
						<CustomDatePicker placeholder="Seleccionar fecha" format="DD/MM/YYYY" style={{ width: '50%' }} />
						<CustomTimePicker placeholder="Seleccionar hora" format="HH:mm" style={{ width: '50%' }} />
					</div>
				</Col>

				<CustomDivider />
			</CustomModal>
			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
